import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const CategoryFilter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const categories = [
    { id: 'all', label: 'All Categories', icon: 'Grid' },
    { id: 'business', label: 'Career & Job Hunting', icon: 'Briefcase' },
    { id: 'strategy', label: 'Business Strategy', icon: 'Target' },
    { id: 'leadership', label: 'Leadership', icon: 'Users' },
    { id: 'innovation', label: 'Innovation', icon: 'Lightbulb' },
    { id: 'operations', label: 'Operations', icon: 'Settings' },
    { id: 'marketing', label: 'Marketing', icon: 'TrendingUp' },
    { id: 'finance', label: 'Finance', icon: 'DollarSign' },
    { id: 'hr', label: 'Human Resources', icon: 'UserCheck' },
    { id: 'technology', label: 'Technology', icon: 'Cpu' }
  ];

  const getActiveCategory = () => {
    const params = new URLSearchParams(location.search);
    return params?.get('category') || 'all';
  };

  const handleCategorySelect = (categoryId) => {
    const params = new URLSearchParams(location.search);
    
    if (categoryId === 'all') {
      params?.delete('category');
    } else {
      params?.set('category', categoryId);
    }

    const searchString = params?.toString();
    navigate(`/e-book-catalog${searchString ? `?${searchString}` : ''}`);
    setIsOpen(false);
  };

  const activeCategory = getActiveCategory();
  const activeCategoryData = categories?.find(cat => cat?.id === activeCategory) || categories?.[0];

  return (
    <div className="bg-card border-b border-border">
      <div className="max-w-[1536px] mx-auto px-6 py-4">
        <div className="hidden lg:flex items-center gap-2 overflow-x-auto">
          {categories?.map((category) => (
            <button
              key={category?.id}
              onClick={() => handleCategorySelect(category?.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-smooth focus-ring ${
                activeCategory === category?.id
                  ? 'bg-primary text-primary-foreground'
                  : 'text-foreground hover:bg-muted'
              }`}
            >
              <Icon name={category?.icon} size={18} />
              {category?.label}
            </button>
          ))}
        </div>

        <div className="lg:hidden relative">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between px-4 py-3 bg-muted rounded-md text-foreground font-medium transition-smooth focus-ring"
            aria-expanded={isOpen}
            aria-label="Category filter"
          >
            <span className="flex items-center gap-2">
              <Icon name={activeCategoryData?.icon} size={20} />
              {activeCategoryData?.label}
            </span>
            <Icon name={isOpen ? 'ChevronUp' : 'ChevronDown'} size={20} />
          </button>

          {isOpen && (
            <>
              <div
                className="fixed inset-0 z-40"
                onClick={() => setIsOpen(false)}
              />
              <div className="absolute top-full left-0 right-0 mt-2 bg-popover rounded-md shadow-lg z-50 py-2 max-h-96 overflow-y-auto">
                {categories?.map((category) => (
                  <button
                    key={category?.id}
                    onClick={() => handleCategorySelect(category?.id)}
                    className={`w-full px-4 py-3 text-left transition-smooth flex items-center gap-3 ${
                      activeCategory === category?.id
                        ? 'bg-primary/10 text-primary font-medium' :'text-popover-foreground hover:bg-muted'
                    }`}
                  >
                    <Icon name={category?.icon} size={20} />
                    {category?.label}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryFilter;